import { useState } from 'react';
import { FileMinus2, FilePlus2, CircleSlash, ClipboardList, type LucideIcon } from 'lucide-react';
import { TerminationRequest } from './TerminationRequest';
import { ReactivationRequest } from './ReactivationRequest';
import { DiscontinuationRequest } from './DiscontinuationRequest';
import { RequestsList } from './RequestsList';

// Hub for the client request forms. One nav entry ("Request Forms") with a tab per
// form plus a separated "Submitted Requests" tab (the log), kept clearly apart from
// the Pending / Completed approval queues. Add a form tab here as each one is built.
interface Tab {
  key: string;
  label: string;
  icon: LucideIcon;
  right?: boolean; // push to the right (the log, separated from the form tabs)
}
const TABS: Tab[] = [
  { key: 'termination', label: 'New Termination Request', icon: FileMinus2 },
  { key: 'reactivation', label: 'New Reactivation Request', icon: FilePlus2 },
  { key: 'discontinuation', label: 'New Discontinuation Request', icon: CircleSlash },
  { key: 'submitted', label: 'Submitted Requests', icon: ClipboardList, right: true },
];

export function RequestForms() {
  const [tab, setTab] = useState<string>('termination');

  return (
    <div className="flex h-full flex-col">
      <div className="flex flex-shrink-0 items-center gap-1 border-b border-border px-6">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = tab === t.key;
          return (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className={`${t.right ? 'ml-auto' : ''} flex items-center gap-2 border-b-2 px-4 py-3 text-sm font-semibold transition-colors ${
                active ? 'border-primary text-primary' : 'border-transparent text-muted-foreground hover:text-primary'
              }`}
            >
              <Icon className="h-4 w-4" />
              {t.label}
            </button>
          );
        })}
      </div>
      <div className="min-h-0 flex-1 overflow-auto">
        {tab === 'termination' && <TerminationRequest />}
        {tab === 'reactivation' && <ReactivationRequest />}
        {tab === 'discontinuation' && <DiscontinuationRequest />}
        {tab === 'submitted' && <RequestsList />}
      </div>
    </div>
  );
}
